<template><div>
  <h1 class="fdd-md--h1">fd-calendar-header</h1>
<h2 class="fdd-md--h2">Props</h2>
<h3 class="fdd-md--h3">month</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>String</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h3 class="fdd-md--h3">year</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Number</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>–</code></p>
<h3 class="fdd-md--h3">hasPrevious</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Function</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>() =&gt; true</code></p>
<h3 class="fdd-md--h3">hasNext</h3>
<p class="fdd-md--p"><strong>Type:</strong> <code>Function</code></p>
<p class="fdd-md--p"><strong>Default:</strong> <code>() =&gt; true</code></p>
<h2 class="fdd-md--h2">Events</h2>
<h3 class="fdd-md--h3">previous</h3>
<p class="fdd-md--p"><strong>Arguments:</strong></p>
<h3 class="fdd-md--h3">month</h3>
<p class="fdd-md--p"><strong>Arguments:</strong></p>
<h3 class="fdd-md--h3">year</h3>
<p class="fdd-md--p"><strong>Arguments:</strong></p>
<h3 class="fdd-md--h3">next</h3>
<p class="fdd-md--p"><strong>Arguments:</strong></p>

  </div></template>
  <script>
  export default {
    mixins: [{
 data() {
  return {
    fddComponentApi: {"componentDesc":{"default":[]},"name":"fd-calendar-header","props":[{"name":"month","type":"String","describe":[]},{"name":"year","type":"Number","describe":[]},{"name":"hasPrevious","type":"Function","describe":[],"default":"() => true"},{"name":"hasNext","type":"Function","describe":[],"default":"() => true"}],"events":[{"name":"previous","isSync":false,"syncProp":"","describe":[]},{"name":"month","isSync":false,"syncProp":"","describe":[]},{"name":"year","isSync":false,"syncProp":"","describe":[]},{"name":"next","isSync":false,"syncProp":"","describe":[]}],"slots":[]}
  };
 }
}
]
  }
  </script>
  